import api from '@/utils/api';

/**
 * Get a dealers' supplier pricing list
 * @param {string} dealerId - Dealer Id
 * @param {string} query - The query
 * @returns {Promise}
 */
const getDealerSupplierPriceListApi = (dealerId, query) => {
  const queryString = query ? `?${query}` : '';
  return api.get(`dealer/${dealerId}/price${queryString}`);
};

export default getDealerSupplierPriceListApi;
